import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { initClient } from '@aliza/nakama-client';
import { App } from './App';
import { getNakamaConfig } from './config/env';
import './global.css';

initClient(getNakamaConfig());

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
